<template>
  <div class="gc-bom-bulk-update-activity-log">
    <div
      v-for="(entry, i) in activityLog"
      :key="entry.Timestamp + '-' + i"
      class="ald-row"
    >
      <div
        class="ald-dot"
        :style="{ backgroundColor: getDotColor(entry.Action) }"
      ></div>
      <span class="ald-time">{{ formatTimestamp(entry.Timestamp) }}</span>
      <div class="ald-content">
        <span class="ald-actor">{{ entry.Actor }}</span>
        <span class="ald-action">{{ entry.Action }}</span>
        <div v-if="entry.Notes" class="ald-notes">{{ entry.Notes }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GcBomBulkUpdateActivityLog",
  props: {
    activityLog: {
      type: Array,
      required: true,
    },
  },
  methods: {
    getDotColor(action) {
      const colorMap = {
        Committed: "#d92d20",
        CommittedWithErrors: "#d92d20",
        Cancelled: "#d92d20",
        StaleDiffAcknowledged: "#f79009",
        DiffRecomputed: "#35baf6",
      };
      return colorMap[action] || "#98A2B3";
    },
    formatTimestamp(dateStr) {
      if (!dateStr) return "—";
      const d = new Date(dateStr);
      return d.toLocaleString("en-AU", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
    },
  },
};
</script>

<style lang="scss">
.gc-bom-bulk-update-activity-log {
  display: flex;
  flex-direction: column;
  width: 100%;

  .ald-row {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 10px 16px;
    border-bottom: 1px solid #eaecf0;
    font-size: 13px;

    &:last-child {
      border-bottom: none;
    }
  }

  .ald-dot {
    width: 8px;
    height: 8px;
    border-radius: 9999px;
    margin-top: 4px;
    flex-shrink: 0;
  }

  .ald-time {
    color: #98a2b3;
    white-space: nowrap;
    min-width: 140px;
    flex-shrink: 0;
  }

  .ald-content {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: row;
    gap: 4px;
  }

  .ald-actor {
    font-weight: 500;
    color: #101828;
  }

  .ald-action {
    color: #475467;
    word-break: break-word;
  }

  .ald-notes {
    color: #98a2b3;
    font-size: 12px;
    font-style: italic;
  }
}
</style>
